import { render } from "./Staff.vue?vue&type=template&id=0aab7cc4&scoped=true"
import script from "./Staff.vue?vue&type=script&lang=js"
export * from "./Staff.vue?vue&type=script&lang=js"

import "./Staff.vue?vue&type=style&index=0&id=0aab7cc4&scoped=true&lang=css"
import "./Staff.vue?vue&type=style&index=1&id=0aab7cc4&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aab7cc4"]])

export default __exports__